<template>
  <template v-for="fob in fobs" :key="fob.text">
    <HeaderDesktopLazyHydratedFlyoutCommon
      v-if="fob.children.length && (isNavSSR || fob.text === flyoutCategoryName)"
      :flyout-category-name="fob.text"
      :is-active="fob.text === flyoutCategoryName"
      :current-fob="fob"
      @close="close"
    />
  </template>
</template>

<script setup>
const emit = defineEmits(['close']);

defineProps({
  flyoutCategoryName: {
    type: String,
    required: true,
  },
  fobs: {
    type: Array,
    required: true,
  },
});

const { isNavSSR } = useEnvProps();

function close() {
  emit('close');
}
</script>
